export default __webpack_public_path__ + "static/media/permission_grant_scopes.71a04ed3.png";